module.exports = __webpack_public_path__ + "img/904-83d0bd.png";